import * as Common from '@/tenant/common';

export class Price extends Common.MasterBase{
  constructor(){
    super('Price');
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.binders.conversion = new Common.ModelBinder(Common.Conversion);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number = 0;
  public commodityId: number = 0;
  public commodity: Common.Commodity  = null;
  public priceType: PriceTypes  = null;
  public skuId: number = 0;
  public sku: Common.SKU = null;
  public counterpart: Common.Counterpart = null;
  public counterpartPriceCategory:  number  = null;
  public currency : string  = '';
  public uom: string  = null;
  public conversion: Common.Conversion = null;
  public set conversion2(conv : Common.Conversion){
    if(conv == null || conv.code == null) this.conversion = null;
    else this.conversion = conv;
  }
  public get conversion2(): Common.Conversion{
    if(this.conversion != null)return this.conversion;
    if(this.commodity != null)return this.commodity.getDefaultConversion();
    return null;
  }
  public startDate: Date  = null;
  public tax: string  = '';
  public price: number  = 0;
  public minimumQuantity1: number  = 0;
  public price1: number  = 0;
  public minimumQuantity2: number  = 0;
  public price2: number  = 0;
  public minimumQuantity3: number  = 0;
  public price3: number  = 0;
  public minimumQuantity4: number  = 0;
  public price4 : number  = 0;
  public minimumQuantity5: number  = 0;
  public price5: number  = 0;
  public minimumQuantity6: number  = 0;
  public price6: number = 0;
  public minimumQuantity7: number  = 0;
  public price7 : number  = 0;
  public minimumQuantity8: number  = 0;
  public price8 : number  = 0;
  public minimumQuantity9: number  = 0;
  public price9: number  = 0;
  
  public copy():any {
    const temp = super.copy() as Price;
    temp.id = 0;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export enum PriceTypes
{
  None = 0,
  SalesPlice = 1,
  PurchasePrice = 2,
}

export enum PriceDisplayTypes
{
  Latest = 1,
}

export class PriceQuery extends Common.LoadQuery {
  constructor(){
    super('PriceQuery',Price);
    this.sort = 'commodity';
  }

  public commodityCode: string  = '';
  public commodityName: string  = '';
  public skuCode: string = '';
  public commodity : Common.Commodity = null;
  public sku : Common.SKU = null;
  public priceType: PriceTypes  = null;
  public priceDisplayType: PriceDisplayTypes  = null;
  public counterpart: Common.Counterpart = null;
  public counterpartPriceCategory: number  = null;
  public currency: string  = '';
  public startDateFrom: Date  = null;
  public startDateTo: Date  = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class PriceImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "PriceImportQuery";
    this.sheetName = sheetName;
    this.hasLicenseCurrency = false;
  }
  public sheetName: string;
  public hasLicenseCurrency: boolean;
}

export class PriceExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "PriceExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.hasLicenseCurrency = false;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
  public hasLicenseCurrency: boolean;
}
